import { money, productId, wishlistId, type Wishlist, type WishlistItem } from '@sshop/domain';

import type { WishlistDto, WishlistItemDto } from './wishlist.dto';

function toItem(dto: WishlistItemDto): WishlistItem {
  return {
    productId: productId(dto.product_id),
    sku: dto.sku,
    slug: dto.slug,
    title: dto.title,
    image: dto.image
      ? {
          url: dto.image.url,
          alt: dto.image.alt,
          ...(dto.image.width !== undefined ? { width: dto.image.width } : {}),
          ...(dto.image.height !== undefined ? { height: dto.image.height } : {}),
        }
      : null,
    price: money(dto.price.amount, dto.price.currency),
    compareAtPrice: dto.compare_at_price
      ? money(dto.compare_at_price.amount, dto.compare_at_price.currency)
      : null,
    inStock: dto.in_stock,
    addedAt: dto.added_at,
  };
}

export function toWishlist(dto: WishlistDto): Wishlist {
  return {
    id: wishlistId(dto.id),
    items: dto.items.map(toItem),
    itemCount: dto.item_count,
    updatedAt: dto.updated_at,
  };
}
